import { CompositionSplitCard } from "../common/CompositionSplit/CompositionSplitCard"
import { UnitProps } from "../unitTypes"

export function SplitMainTab(props: UnitProps) {
  const {data, unit} = props;
  return <CompositionSplitCard className='mt-1' data={data} unit={unit} splitterId={unit.id} />
}